export const Messages = {
    FileSizeExceedWarning: 'PDF size must be smaller than 5MB !',
    InvitationResend: 'Invitation resent successfully',
    CandidateInviteFailed: 'Sorry, Only Personal Accounts are allowed to invite.',
    EmployeeInviteFailed: 'Sorry, Personal Accounts are not allowed to invite.'
};


